<template>
	<BaseCatalogWishlistWidget v-slot="{counter, wishlistUrl}">
		<ClientOnly>
			<div class="wishlist-widget" :class="{'active': counter > 0}">
				<BaseAuthUser v-slot="{user, urls}">
					<NuxtLink :to="user?.b2b ? urls.auth_wishlist : wishlistUrl">
						<BaseCmsLabel code="wishlist" />
					</NuxtLink>
				</BaseAuthUser>
			</div>
		</ClientOnly>
	</BaseCatalogWishlistWidget>
</template>

<script setup>
	const props = defineProps({
		item: Object,
		mode: String,
	});
</script>

<style lang="less" scoped>
	.wishlist-widget{
		position: relative;
		a{
			width: 50px; height: 50px; position: relative; display: flex; justify-content: center; align-items: center; font-size: 0; border-right: 1px solid rgba(255,255,255,0.2);
			&:before{.icon-wishlist; font: 18px/18px var(--fonti); color: var(--white); position: absolute; left: 0; top: 0; width: 50px; height: 50px; display: flex; justify-content: center; align-items: center;}
		}
		@media (max-width: @l){
			a{
				width: 44px; height: 44px; 
				&:before{font-size: 17px; line-height: 17px; width: 44px; height: 44px;}
			}
		}
		@media (max-width: @tp){
			position: absolute; right: 62px;
			a{
				width: 22px; height: 56px; border-right: 0;
				&:before{font-size: 20px; line-height: 20px; width: 22px; height: 56px;}
			}
		}
	}
</style>